<template>
   <div class="container">
    <div class="row">
      <div class="col-sm-12  col-md-3 sidebar">
  <div class="item menuItems">
    <RouterLink to="/" class="{ 'active-link': $route.path === '/' }"><img src="../assets/home.png" alt="Home" id="icons"><span style="padding-left: 15px;">Home</span> </RouterLink>
    <RouterLink to="/requiredDisclosure"><img src="../assets/disclosure.png" alt="509 Disclosure" id="icons"><span style="padding-left: 15px;">509 Required Disclosure</span></RouterLink>
    <RouterLink to="/employmentOutcomes"><img src="../assets/employment.png" alt="Employment Outcomes" id="icons"><span style="padding-left: 15px;">Employment Outcomes</span></RouterLink>
    <RouterLink to="/barPassageOutcomes"><img src="../assets/barpassage.png" alt="Bar Passage Outcomes" id="icons"><span style="padding-left: 15px;">Bar Passage Outcomes</span></RouterLink>
    <a id="terms" data-bs-toggle="modal" data-bs-target="#termsPopUp"><img src="../assets/terms.png" alt="Terms" id="icons"><span style="padding-left: 15px;">Terms Of Use</span></a>
  </div>
  
</div>
<div class="col-sm-12 col-md-9">
  <div class="item mainView">
    <main>
      <RouterView />
    </main>
  </div>
    
  </div>
  </div>
</div>
<div class="modal fade" id="termsPopUp">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Terms of Use</h4>
        <button type="button" class="btn-close" id="btn-close" title="Close Modal" data-bs-dismiss="modal"></button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <p>All data inputted into the ABA Section of Legal Education and Admissions to the Bar Questionnaire is confidential except as provided by applicable ABA Standards and Rules of Procedure for Approval of Law Schools, including <a :href="abaStandardsLink" @click.prevent="openInNewTab(abaStandardsLink)"> Standard 509</a> and Rule 27.</p>
        <p>For the complete list of the ABA Standards, please click here <a :href="abaFullStandardsLink" @click.prevent="openInNewTab(abaFullStandardsLink)">ABA Standards</a>.</p>
      </div>

      <!-- Modal footer -->
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
      </div> -->

    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'SideMenu',

  data() {
    return {
      abaStandardsLink: 'https://www.americanbar.org/content/dam/aba/administrative/legal_education_and_admissions_to_the_bar/governancedocuments/2013_standard_509_memo.authcheckdam.pdf',
      abaFullStandardsLink: 'https://www.americanbar.org/groups/legal_education/resources/standards/'
    };
  },


  methods: {
    openInNewTab(url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>


.mainView {
  height: 100%;
  z-index: 1;
  top: 0;
  left: 0;
  overflow-x: hidden;
}

.menuItems {
    flex:1;
    padding-top:2%;
    height:auto;
    padding-bottom:4.4vh;

}
.sidebar {
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  height: 100%;
}

    .sidebar a {
        padding: 8px 8px 8px 30px;
        text-decoration: none;
        color: white;
        display: block;
        font-family: 'Helvetica';
        margin-left: 25px;
        margin-right: 25px;
        font-size: 16px;
        font-weight: 700;
        line-height: 15.92px;
        letter-spacing: 0.003em;
        text-align: left;
    }

        .sidebar a:hover {
            color: #0077B5;
            background-color: white;
            font-family: 'Helvetica';
            border-radius: 25px;
            font-size: 16px;
            font-weight: 700;
            line-height: 15.92px;
            letter-spacing: 0.003em;
            text-align: left;
        }

.router-link-active {
  color: #0077B5 !important;
  font-weight: 700 !important;
}
    #terms {
        margin-top: 25vw;
        color: white;
        font-family: 'Helvetica';
        font-size: 16px;
        font-weight: 700;
        line-height: 15.92px;
        letter-spacing: 0.003em;
        text-align: left;
    }

        #terms:hover {
            color: #0077B5;
            background-color: white;
            font-family: 'Helvetica';
            margin-right: 15px;
            border-radius: 25px;
            font-size: 16px;
            font-weight: 700;
            line-height: 15.92px;
            letter-spacing: 0.003em;
            text-align: left;
            cursor: pointer;
        }

#icons{
  color: white;
  height: 24px;
  width: 24px;
}

.col-md-3{
  padding-left: 0;
  padding-right: 0px;
  height: auto;
}
.col-md-9{
  padding-left: 0;
  padding-right: 12px;
}
.container{
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  padding-bottom: 0;
  max-width: fit-content;
  margin-right: 0;
}

</style>
